import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function StrategyHistory() {
  const navigate = useNavigate();
  const [filterType, setFilterType] = useState<'all' | 'loan' | 'wealth'>('all');

  const historyStrategies = [
    {
      id: 1,
      customerName: '张伟',
      companyName: '深圳科技有限公司',
      type: 'loan',
      typeName: '贷前AI策略',
      date: '2024-01-20',
      time: '14:30',
      status: 'success',
      avatar: 'https://public.readdy.ai/ai/img_res/0cd8dc70af0f7f8f6b9bc836d0c9f88e.jpg',
      summary: '信用评分850分，建议授信500万',
      tags: ['低风险', '优质客户', '科技制造']
    },
    {
      id: 2,
      customerName: '李华',
      companyName: '广州贸易集团',
      type: 'wealth',
      typeName: '财富推荐策略',
      date: '2024-01-19',
      time: '16:45',
      status: 'success',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20chinese%20businesswoman%20portrait%2C%20clean%20white%20background%2C%20business%20attire%2C%20confident%20smile%2C%20high%20quality%20headshot&width=60&height=60&seq=hist2&orientation=squarish',
      summary: '资产配置优化，年化收益预期8.5%',
      tags: ['风险均衡', '资产配置', '贸易行业']
    },
    {
      id: 3,
      customerName: '王明',
      companyName: '上海制造有限公司',
      type: 'loan',
      typeName: '贷前AI策略',
      date: '2024-01-19',
      time: '10:20',
      status: 'success',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20middle-aged%20chinese%20businessman%20portrait%2C%20clean%20white%20background%2C%20business%20suit%2C%20serious%20expression%2C%20high%20quality%20headshot&width=60&height=60&seq=hist3&orientation=squarish',
      summary: '信用评分780分，建议授信300万',
      tags: ['中等风险', '制造业', '成长期']
    },
    {
      id: 4,
      customerName: '陈雪',
      companyName: '北京投资管理公司',
      type: 'wealth',
      typeName: '财富推荐策略',
      date: '2024-01-18',
      time: '15:10',
      status: 'success',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20chinese%20businesswoman%20portrait%2C%20clean%20white%20background%2C%20elegant%20business%20attire%2C%20confident%20expression%2C%20high%20quality%20headshot&width=60&height=60&seq=hist4&orientation=squarish',
      summary: '高净值客户，建议私募股权配置',
      tags: ['高净值', '投资偏好', '风险承受']
    },
    {
      id: 5,
      customerName: '赵强',
      companyName: '杭州电子科技',
      type: 'loan',
      typeName: '贷前AI策略',
      date: '2024-01-18',
      time: '09:30',
      status: 'success',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20young%20chinese%20businessman%20portrait%2C%20clean%20white%20background%2C%20modern%20business%20attire%2C%20friendly%20smile%2C%20high%20quality%20headshot&width=60&height=60&seq=hist5&orientation=squarish',
      summary: '科创企业，建议创新贷400万',
      tags: ['科技创新', '高增长', '政策支持']
    },
    {
      id: 6,
      customerName: '孙丽',
      companyName: '成都医疗器械',
      type: 'wealth',
      typeName: '财富推荐策略',
      date: '2024-01-17',
      time: '14:15',
      status: 'success',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20chinese%20businesswoman%20portrait%2C%20clean%20white%20background%2C%20medical%20industry%20professional%20attire%2C%20confident%20expression%2C%20high%20quality%20headshot&width=60&height=60&seq=hist6&orientation=squarish',
      summary: '稳健配置为主，债券基金70%',
      tags: ['稳健型', '医疗行业', '保守投资']
    }
  ];

  const filteredStrategies = filterType === 'all' 
    ? historyStrategies 
    : historyStrategies.filter(item => item.type === filterType);

  const handleStrategyClick = (strategy: any) => {
    if (strategy.type === 'loan') {
      navigate('/strategy-report-detail');
    } else {
      navigate('/strategy-report-wealth-detail');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 pb-20">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-5 pt-10 pb-4 sticky top-0 z-10">
        <div className="flex items-center gap-3 mb-2">
          <button onClick={() => navigate('/dashboard')} className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm">
            <i className="ri-arrow-left-line text-lg"></i>
          </button>
          <h1 className="text-xl font-bold flex-1">AI策略历史</h1>
          <button onClick={() => navigate('/strategy-report')} className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm">
            <i className="ri-robot-line text-lg"></i>
          </button>
        </div>
        <div className="text-sm text-blue-100">查看历史生成的AI策略报告</div>
      </div>

      <div className="px-5 -mt-3">
        {/* Filter Tabs */}
        <div className="bg-white rounded-2xl shadow-lg p-2 mb-5">
          <div className="flex bg-gray-100 rounded-xl p-1">
            <button
              onClick={() => setFilterType('all')}
              className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all ${
                filterType === 'all'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              全部
            </button>
            <button
              onClick={() => setFilterType('loan')}
              className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all ${
                filterType === 'loan'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              贷前策略
            </button>
            <button
              onClick={() => setFilterType('wealth')}
              className={`flex-1 py-2 px-4 rounded-lg text-sm font-medium transition-all ${
                filterType === 'wealth'
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-600 hover:text-blue-600'
              }`}
            >
              财富策略
            </button>
          </div>
        </div>

        {/* Statistics */}
        <div className="bg-white rounded-2xl shadow-lg p-5 mb-5">
          <div className="grid grid-cols-3 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-blue-600 mb-1">{historyStrategies.length}</div>
              <div className="text-xs text-gray-600">总策略数</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600 mb-1">{historyStrategies.filter(s => s.type === 'loan').length}</div>
              <div className="text-xs text-gray-600">贷前策略</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-purple-600 mb-1">{historyStrategies.filter(s => s.type === 'wealth').length}</div>
              <div className="text-xs text-gray-600">财富策略</div>
            </div>
          </div>
        </div>

        {/* Strategy List */}
        <div className="space-y-3">
          {filteredStrategies.map((strategy) => (
            <div
              key={strategy.id}
              onClick={() => handleStrategyClick(strategy)}
              className="bg-white rounded-2xl shadow-lg p-5 cursor-pointer active:scale-98 transition-transform"
            >
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src={strategy.avatar}
                  alt={strategy.customerName}
                  className="w-12 h-12 rounded-xl object-cover"
                />
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-bold text-gray-800">{strategy.customerName}</span>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      strategy.type === 'loan' 
                        ? 'bg-blue-100 text-blue-700' 
                        : 'bg-purple-100 text-purple-700'
                    }`}>
                      {strategy.typeName}
                    </span>
                  </div>
                  <div className="text-sm text-gray-600">{strategy.companyName}</div>
                </div>
                <div className="text-right">
                  <div className="text-xs text-gray-500">{strategy.date}</div>
                  <div className="text-xs text-gray-400">{strategy.time}</div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-xl p-3 mb-3">
                <div className="text-sm text-gray-700 mb-2">AI分析摘要</div>
                <div className="text-sm font-medium text-gray-800">{strategy.summary}</div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex flex-wrap gap-1">
                  {strategy.tags.map((tag, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-1 text-blue-600">
                  <span className="text-xs">查看详情</span>
                  <i className="ri-arrow-right-s-line text-sm"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredStrategies.length === 0 && (
          <div className="text-center py-20">
            <div className="w-20 h-20 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-4">
              <i className="ri-file-list-3-line text-3xl text-gray-400"></i>
            </div>
            <div className="text-gray-500 mb-2">暂无策略记录</div>
            <button
              onClick={() => navigate('/strategy-report')}
              className="text-blue-600 text-sm font-medium"
            >
              立即生成AI策略
            </button>
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-5 py-3 grid grid-cols-5 gap-2">
        <button onClick={() => navigate('/customer-filter')} className="flex flex-col items-center gap-1 text-gray-400">
          <i className="ri-user-search-line text-xl"></i>
          <span className="text-xs">客户</span>
        </button>
        <button onClick={() => navigate('/strategy-report')} className="flex flex-col items-center gap-1 text-gray-400">
          <i className="ri-file-text-line text-xl"></i>
          <span className="text-xs">AI策略</span>
        </button>
        <button onClick={() => navigate('/ai-chat')} className="flex flex-col items-center gap-1 text-gray-400">
          <i className="ri-chat-smile-3-line text-xl"></i>
          <span className="text-xs">AI问答</span>
        </button>
        <button onClick={() => navigate('/best-cases')} className="flex flex-col items-center gap-1 text-gray-400">
          <i className="ri-trophy-line text-xl"></i>
          <span className="text-xs">最佳案例</span>
        </button>
        <button onClick={() => navigate('/profile')} className="flex flex-col items-center gap-1 text-gray-400">
          <i className="ri-user-line text-xl"></i>
          <span className="text-xs">我的</span>
        </button>
      </div>
    </div>
  );
}